module.exports = __webpack_public_path__ + "img/cur15.ecf90c57.png";